



























// @ts-nocheck

import Vue from 'vue'
import RateButton from './components/RateButton.vue';
import NoBox from './components/NoBox.vue';
import YesBox from './components/YesBox.vue';

import { IState, ApplicationState, Answer } from './store/state';
import { rate, setApplicationState } from './store/actions';

import { WidgetInstance } from "friendly-challenge";

// Interfaces for component typechecking!
interface AppData {
	done: boolean;
	showCaptcha: boolean;
	solution: string;
	value: string;
}

interface AppMethods {
	rateYes(): void;
	rateNo(): void;
	initCaptcha(answer: string): void;
	captchaDone(solution: string): void;
}

interface AppComputed {
	fcSiteId: string;
	title: string;
	label: string;
	showResult: boolean;
	answer: Answer;
}

interface AppProps {

}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'app',
	data() {
		return {
			done: false,
			showCaptcha: false,
			solution: '',
			value: 'NONE'
		}
	},
	computed: {
		fcSiteId(){
			return (this.$store.state as IState).fcSiteId;
		},
		title(){
			return (this.$store.state as IState).strings.main.title;
		},
		label() {
			return (this.$store.state as IState).strings.main.label;
		},
		showResult() {
			return this.$store.state.applicationState !== ApplicationState.RATE && !this.done
		},
		answer(){
			return this.$store.state.answer;
		}
	},
	methods: {
		rateYes(){
			this.$store.dispatch(rate({
				answer: 'Y',
				nextState: ApplicationState.THANKS,
				solution: this.solution
			}))
		},
		rateNo(){
			this.$store.dispatch(rate({
				answer: 'N',
				nextState: ApplicationState.FORM,
				solution: this.solution,
			}))
		},
		initCaptcha(answer: string){
			this.showCaptcha = true;
			this.value = answer;
		},
		captchaDone(solution: string) {
			this.solution = solution;
			if(this.value === 'Y'){
				this.rateYes();
			} else {
				this.rateNo();
			}
		}
	},
	components: {
		RateButton,
		NoBox,
		YesBox
	},
	mounted(){
		// @ts-ignore
		new WidgetInstance(this.$refs.friendlyCaptchaElement, {
			startMode: "focus",
			doneCallback: this.captchaDone,
		});
	}})
